// @generated by protoc-gen-es v2.6.3 with parameter "keep_empty_files=true,target=js+dts"
// @generated from file proto/model/core/place_types/culture.proto (package carmen, syntax proto3)
/* eslint-disable */

import { enumDesc, fileDesc, tsEnum } from "@bufbuild/protobuf/codegenv2";

/**
 * Describes the file proto/model/core/place_types/culture.proto.
 */
export const file_proto_model_core_place_types_culture = /*@__PURE__*/
  fileDesc("Cipwcm90by9tb2RlbC9jb3JlL3BsYWNlX3R5cGVzL2N1bHR1cmUucHJvdG8SBmNhcm1lbiqFAwoQQ3VsdHVyZVBsYWNlVHlwZRIiCh5DVUxUVVJFX1BMQUNFX1RZUEVfVU5TUEVDSUZJRUQQABIiCh5DVUxUVVJFX1BMQUNFX1RZUEVfQVJUX0dBTExFUlkQARIhCh1DVUxUVVJFX1BMQUNFX1RZUEVfQVJUX1NUVURJTxACEiEKHUNVTFRVUkVfUExBQ0VfVFlQRV9BVURJVE9SSVVNEAMSKAokQ1VMVFVSRV9QTEFDRV9UWVBFX0NVTFRVUkFMX0xBTkRNQVJLEAQSJwojQ1VMVFVSRV9QTEFDRV9UWVBFX0hJU1RPUklDQUxfUExBQ0UQBRIfChtDVUxUVVJFX1BMQUNFX1RZUEVfTU9OVU1FTlQQBhIdChlDVUxUVVJFX1BMQUNFX1RZUEVfTVVTRVVNEAcSLgoqQ1VMVFVSRV9QTEFDRV9UWVBFX1BFUkZPUk1JTkdfQVJUU19USEVBVEVSEAgSIAocQ1VMVFVSRV9QTEFDRV9UWVBFX1NDVUxQVFVSRRAJQihaJmdpdGh1Yi5jb20veXVuYWNhYmEvY2FybWVuL3Byb3RvL21vZGVsYgZwcm90bzM");

/**
 * Describes the enum carmen.CulturePlaceType.
 */
export const CulturePlaceTypeSchema = /*@__PURE__*/
  enumDesc(file_proto_model_core_place_types_culture, 0);

/**
 * Culture-related place types
 *
 * @generated from enum carmen.CulturePlaceType
 */
export const CulturePlaceType = /*@__PURE__*/
  tsEnum(CulturePlaceTypeSchema);

